var React = require('react');

function ExpandLess (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z","key":0}),React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":1})]);
}

ExpandLess.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ExpandLess;

ExpandLess.default = ExpandLess;
